const primeState = {
  driverAssetsIssuedList: [],
  prevPage: -1,
  nextPage: -1,
  currentPageAssets: 1,
  activeFilters: {},
  cities: [],
  onboardingCenters: [],
  driverAssetsAvailableList: [],
  recentAssetStatus: {},
  paymentStatus: {},
};

export default primeState;
